<template>
  <div
    :class="['sign-tit-wrap', simplicity ? 'simplicity' : '']"
    :style="`width:${width}px;height:${height}px`"
  >
    <div class="sign-tit">
      <div class="sign" :style="`background: ${color}`"></div>
      <span>{{ title }}</span>
    </div>
    <van-icon v-if="arrows" name="arrow" size="20px" />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#16d77a"
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 335
    },
    height: {
      type: String,
      default: "50px"
    },
    arrows: {
      type: Boolean,
      default: false
    },
    simplicity: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-tit-wrap {
  height: 50px;
  display: flex;
  justify-content: space-between;
  width: 335px;
  &.simplicity {
    .sign-tit {
      font-size: 20px;
      font-weight: 700;
      color: #000;
      .sign {
        display: none;
      }
    }
  }
  .sign-tit {
    display: flex;
    align-items: center;
    height: 100%;
    font-weight: 700;
    font-size: 14px;
    color: #666;
    .sign {
      position: relative;
      height: 18px;
      width: 5px;
      border-radius: 2px;
      margin-right: 3px;
    }
  }
  .van-icon {
    display: flex;
    align-items: center;
  }
}
</style>
